module.exports = __webpack_public_path__ + "img/amex.6bc1674b.jpg";